
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(4(0433|4176|9519)|54(18|582)|1730|18555|61549|69357|72399|75663)$/.test(chunkId);
},
rootOutputDir: "",

    };
}
